import {
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    // Link,
    Stack,
    Image,
  } from '@chakra-ui/react';

  import Swal from 'sweetalert2'

  import { useNavigate } from 'react-router-dom';
  import { useState } from 'react';

  import { useDispatch } from 'react-redux';
  import { login } from '../../features/authSlice/authSlice.js';

  import {axiosInstance} from '../../lib/api.js'


  
  export default function Login() {

    // const authSelector = useSelector((state) => state.auth['token'])
    const dispatch = useDispatch()

    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()


    const handleSubmitForLogin  = (e) => {
        e.preventDefault();
        setLoading(true)
        axiosInstance.post('auth/jwt/create/', {
          email: email,
          password: password
        })
        .then(res => {
          dispatch(login({
            token: res.data.access,
            refresh_token: res.data.refresh,
          }))
          localStorage.setItem('access', res.data.access)
          axiosInstance.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('access')}`
          if(res.status === false){
            navigate('/login')
          }
          Swal.fire(
            'Login Successful',
            'Redirecting to Dashboard',
            'info'
          )
          navigate('/dashboard')
        })
        .catch(err => {
          const { response } = err
          setError(response.data.detail)
          Swal.fire(
            error,
          )
          navigate('/login')
          setLoading(false)
      })
    }

    return (
      <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
        <Flex p={8} flex={1} align={'center'} justify={'center'}>
          <form onSubmit={handleSubmitForLogin} method='post'>
          <Stack spacing={4} w={'full'} maxW={'md'}>
            <Heading fontSize={'2xl'}>Sign in to your account</Heading>
            <FormControl id="email">
              <FormLabel>Email address</FormLabel>
              <Input type="email" value={email} onChange={(e) =>setEmail(e.target.value) } />
            </FormControl>
            <FormControl id="password">
              <FormLabel>Password</FormLabel>
              <Input type="password" value={password} onChange={(e) =>setPassword(e.target.value) }/>
            </FormControl>
            <Stack spacing={6}>
              <Stack
                direction={{ base: 'column', sm: 'row' }}
                align={'start'}
                justify={'space-between'}>
                <Checkbox>Remember me</Checkbox>
                {/* <Link color={'blue.500'}>Forgot password?</Link> */}
              </Stack>
              <Button colorScheme={'blue'} variant={'solid'} type={'submit'} loadingText={'Submitting'} opacity={loading ? 0.5 : 1} isDisabled={loading ? true : false}>
              {loading ? 'Loading...' : 'Sign In'}
              </Button>
            </Stack>
          </Stack>
          </form>
        </Flex>
        <Flex flex={1}>
          <Image
            alt="Coin placed over dollar note"
            objectFit={'cover'}
            src={
              'https://images.unsplash.com/photo-1622186477895-f2af6a0f5a97?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'
            }
          />
        </Flex>
      </Stack>
    );
  }